<template>
  <div>
    <el-form-item label="文件名" prop="content.fileName">
      <el-input v-model="modelValue.fileName" placeholder="请输入导出文件名" />
    </el-form-item>

    <el-form-item label="SQL语句" prop="content.sql">
      <el-input 
        v-model="modelValue.sql" 
        type="textarea" 
        :rows="5" 
        placeholder="请输入SQL语句"
      />
    </el-form-item>

    <el-form-item label="钉钉Webhook" prop="content.webHookUrl">
      <el-input v-model="modelValue.webHookUrl" placeholder="请输入钉钉机器人Webhook地址" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue']
}
</script>
